export const breakpoint = {
  xxs: 413.98,
  xs: 575.98,
  sm: 767.98,
  md: 991.98,
  lg: 1199.98,
  xl: 1439.98,
};
